/* template */
<template minapp="mpx" xlang="wxml"><from-item :isShow="(isShow)" :isRequired="(isRequired)" :isRequiredShow="(isRequiredShow)" label="乘客类型" :innerValue="(showValue)" :isDisable="(isPassengerTypeDisable)"><div slot="input" class="es-content__type"><mpx-view v-for="(item, index) in (typeList)" :class='("type-item "+(innerValue === item.value ? "selected" : ""))' @tap="selectType(item.value)"><span class="type-text">{{item.label}}</span><div class="type-item-selected-icon" v-if="(innerValue === item.value)"><es-icon size="6" name="check" color="#fff"/></div></mpx-view></div></from-item></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3df7ee35"}'>
  +b('content')
    +e('type')
      display flex
      align-items center
      color #333333
      .type-item
        display flex
        align-items center
        justify-content: center;
        width 60px
        height 24px
        margin-right 12px
        padding 8px
        border-radius 4px
        background #F6F8FA
        position relative
        box-sizing border-box
        &.selected
          background #EDF4FF
          border 0.5px solid #438FFF
          color #1473FF
        &-selected-icon
          width 12px
          height 8px
          border-radius 4px 0px 4px 0px
          background #1473FF
          display flex
          align-items center
          justify-content center
          position absolute
          right 0
          bottom 0
      .type-text
        font-size 12px
        // margin-left 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3df7ee35"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./contact-type.mpx.js?isComponent&outputPath=components%2Fcontact-type3df7ee35%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./contact-type.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcontact-type3df7ee35%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3df7ee35"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/contact-type3df7ee35/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'from-item':getComponent(require("./from-item.mpx?isComponent&outputPath=components%2Ffrom-item141a5554%2Findex")),'radio-circle':getComponent(require("../../radio-circle/index.mpx?isComponent&outputPath=components%2Findex17a49170%2Findex")),'es-cell':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/cell/index.mpx?isComponent&outputPath=components%2Findex1902b88c%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
